import React, { Component } from 'react';
import { Row, Col, TextField } from 'emerald-ui';
import PropTypes from 'prop-types';
import { isComplexPassword } from '../../utils';
import { verifyIfUserExists } from '../../api/users';

class SignUpFormAccessInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userExists: false,
    };
  }

  isValidPassword = false;

  handleChange = (key) => (event) => {
    const value = event.target.value;
    this.props.handleFieldChange({ [key]: value });
    this.props[key].displayErrors = false;
  };

  handleUsernameChange = async (event) => {
    const value = event.target.value;
    if (value) {
      const response = (await verifyIfUserExists(value)).data;
      this.setState({ userExists: response.exists });
    }
  };

  handlePasswordChange = (event) => {
    const validation = isComplexPassword(event.target.value);
    const passwordErrorMsg = !validation.result && validation.error && (
      <ul>
        {validation.error.map((error) => {
          return <li key={error}>{error}</li>;
        })}
      </ul>
    );
    this.isValidPassword = validation.result;
    this.props.password.displayErrors = true;
    this.props.password.setError(passwordErrorMsg);
    this.setState({ errors: validation.result });
  };

  handleConfirmPasswordChange = (event) => {
    const { password, confirmPassword } = this.props;
    if (password.value !== confirmPassword.value) {
      confirmPassword.displayErrors = true;
      confirmPassword.setError(`Passwords don't match`);
      this.setState({ errors: true });
    }
  };

  render() {
    const { username = {}, password = {}, confirmPassword = {} } = this.props;
    return (
      <Row>
        <Col xs={12} md={5}>
          <div className="sign-up-form-description">
            <p>Access information</p>
            <p>Enter a user name and password to access your account</p>
          </div>
        </Col>
        <Col xs={12} md={7}>
          <div className="sign-up-fields-section">
            <TextField
              id="username"
              shape="classic"
              label="Login"
              maxLength="40"
              onChange={this.handleChange('username')}
              onBlur={this.handleUsernameChange}
              value={username.value || ''}
              error={username.displayErrors ? username.errorMsg : this.state.userExists ? 'Login already exists' : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="password"
              shape="classic"
              placeholder="*******"
              label="Password"
              type="password"
              onChange={this.handleChange('password')}
              onBlur={this.handlePasswordChange}
              value={password.value || ''}
              error={password.displayErrors ? password.errorMsg : ''}
            />
          </div>
          <div className="sign-up-fields-section">
            <TextField
              id="confirmPassword"
              shape="classic"
              placeholder="*******"
              type="password"
              label="Confirm password"
              disabled={!this.isValidPassword}
              onChange={this.handleChange('confirmPassword')}
              onBlur={this.handleConfirmPasswordChange}
              value={confirmPassword.value || ''}
              error={confirmPassword.displayErrors ? confirmPassword.errorMsg : ''}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

SignUpFormAccessInfo.propTypes = {
  handleFieldChange: PropTypes.func,
  getFieldValue: PropTypes.func,
  username: PropTypes.object,
  password: PropTypes.object,
  confirmPassword: PropTypes.object,
};

SignUpFormAccessInfo.defaultProps = {
  handleFieldChange: () => {},
  getFieldValue: () => {},
  username: {},
  password: {},
  confirmPassword: {},
};

export default SignUpFormAccessInfo;



// WEBPACK FOOTER //
// ./src/components/SignUpFormAccessInfo/SignUpFormAccessInfo.js